export const environment = {
  apiUrl: "https://api2dev.eyelation.com/api",
  defaultRedirectUri: "https://deveyeonline.eyelation.com",
  adminRedirectUri: "https://devadmin.eyelation.com/",
  environmentName: "Development",
  production: false,
  supportEmail: "questions@eyelation.com",
  workosClientId: "client_01JQ4DB4TFDP1BSSTTCQC2ZHPJ",
  workosUrl: "https://significant-strength-91-staging.authkit.app",
};
